export default __webpack_public_path__ + "static/media/pencil_light.39a1f147.svg";